import { call, put, takeLatest } from 'redux-saga/effects'
import { PayloadAction } from '@reduxjs/toolkit'
import { t } from 'i18next'
import apiCall from '../helpers/apiCall'
import { POST } from '../consts/methods'
import { SET_LOADER } from 'dealer-reducers'
import { FETCH_PROMOTIONS, MobileListingActionPayload, RESUME_MOBILE_LISTING } from 'src/redux/promotionsReducer'
import { SHOW_TOAST } from 'src/redux/toastReducer'
import { specificMobileError } from 'src/helpers/mobileApiError'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* ResumeMobileListingFlow(action: PayloadAction<MobileListingActionPayload>): Generator<any, void, any> {
  try {
    yield put(SET_LOADER(true))
    const { motorbikeId, promotionId } = action.payload
    yield call(apiCall, {
      endpoint: `/dealers_api/motorbikes/${motorbikeId}/mobile_listings/${promotionId}/resume`,
      api: 'market-api',
      method: POST,
      params: {}
    })
    yield put(FETCH_PROMOTIONS(motorbikeId))
    yield put(SHOW_TOAST({ message: t('my_vehicles.toast_promotion_resumed') }))
  } catch (error) {
    const message = error instanceof Error ? error.message : ''
    yield put(SHOW_TOAST({ message: specificMobileError(message, t) ?? t('my_vehicles.promotion_create_error') }))
  } finally {
    yield put(SET_LOADER(false))
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* ResumeMobileListingSaga(): Generator<any, void, any> {
  yield takeLatest(RESUME_MOBILE_LISTING, ResumeMobileListingFlow)
}
